import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  closeButton: {
    marginRight: "8px"
  },
  closeButtonIcon: {
    color: "#333333",
    fontSize: "32px"
  }
}));
